module.exports = "/_next/static/images/zubair-b0f5c63cc25a4b48dc063bde35602f66.png";